import { lazy } from 'react';

import type { WidgetMapper } from 'ui/containers/ContentBuilder';

export const componentsMapper: WidgetMapper = {
  EudoraInfo: lazy(() => import('./EudoraInfo')),
  Logout: lazy(() => import('./Logout')),
  Loyalty: lazy(() => import('./Loyalty')),
};
